export const CalcExpiryDate = (hours: number, creationDate: string): Date => {
    let date = new Date(creationDate);
    const milliseconds = hours * 60 * 60 * 1000; // convert hours to milliseconds
    date.setTime(date.getTime() + milliseconds);
    return new Date(date);
};
